// extracted by mini-css-extract-plugin
export default {"tooltip":"yo-z","sharingV2":"zo-z","sharingIconsV2":"Ao-z","links":"Bo-z","link":"Co-z","facebookV2":"Do-z","twitterV2":"Eo-z","pinterestV2":"Fo-z"};